import {ValueDefinition} from '@/model/types';

export const DV_32 = {
  id: 'DV-32',
  description: {
    fr: 'Compte d’investissement de la Capitale et Beneva',
    en: 'Capital Investment and Beneva Account',
  },
  type: 'InvestmentAccount',
  values: [
    {
      id: '02',
      value: {
        fr: 'Revenu fixe canadien (AGF)',
        en: 'Canadian Fixed Income (AGF)',
      },
      properties: {
        id_beneva: 'AB',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '03',
      value: {
        fr: 'Équilibré canadien (Dynamique)',
        en: 'Canadian Balanced (Dynamic)',
      },
      properties: {
        id_beneva: 'AC',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '04',
      value: {
        fr: 'Équilibré canadien (Fidelity)',
        en: 'Canadian Balanced (Fidelity)',
      },
      properties: {
        id_beneva: 'AD',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '05',
      value: {
        fr: 'Équilibré mondial (AGF)',
        en: 'Global Balanced (AGF)',
      },
      properties: {
        id_beneva: 'AE',
        DtDb: '2007-12-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '06',
      value: {
        fr: 'Revenu diversifié (Fidelity)',
        en: 'Diversified Income (Fidelity)',
      },
      properties: {
        id_beneva: 'AF',
        DtDb: '2012-11-26',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '07',
      value: {
        fr: 'Revenu diversifié (Dynamique)',
        en: 'Diversified Income (Dynamic)',
      },
      properties: {
        id_beneva: 'AG',
        DtDb: '2012-11-26',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '09',
      value: {
        fr: 'Dividendes canadiens (AGF)',
        en: 'Canadian Dividend (AGF)',
      },
      properties: {
        id_beneva: 'AI',
        DtDb: '2007-12-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '10',
      value: {
        fr: 'Dividendes canadiens (Fidelity)',
        en: 'Canadian Dividend (Fidelity)',
      },
      properties: {
        id_beneva: 'AJ',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '11',
      value: {
        fr: 'Actions canadiennes de revenu (Dynamique)',
        en: 'Canadian Equity Income (Dynamic)',
      },
      properties: {
        id_beneva: 'AK',
        DtDb: '2012-11-26',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '12',
      value: {
        fr: 'Actions canadiennes (Dynamique)',
        en: 'Canadian Equity (Dynamic)',
      },
      properties: {
        id_beneva: 'AL',
        DtDb: '2007-12-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '13',
      value: {
        fr: 'Actions canadiennes (Fidelity)',
        en: 'Canadian Equity (Fidelity)',
      },
      properties: {
        id_beneva: 'AM',
        DtDb: '2011-10-10',
        DtEx: '2199-01-01',
        DtFi: '2199-01-01',
      },
    },
    {
      id: '14',
      value: {
        fr: 'Actions canadiennes petites capitalisations (Dynamique)',
        en: 'Small Capitalization Canadian Equity (Dynamic)',
      },
      properties: {
        id_beneva: 'AN',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '15',
      value: {
        fr: 'Actions canadiennes à faible volatilité (GPTD)',
        en: 'Low Volatility Canadian Equity (TDAM)',
      },
      properties: {
        id_beneva: 'AO',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '18',
      value: {
        fr: 'Actions américaines (Dynamique)',
        en: 'American Equity (Dynamic)',
      },
      properties: {
        id_beneva: 'AR',
        DtDb: '2007-12-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '20',
      value: {
        fr: 'Actions mondiales – découverte (Dynamique)',
        en: 'Global Equity - Discovery (Dynamic)',
      },
      properties: {
        id_beneva: 'AT',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '21',
      value: {
        fr: 'Actions mondiales à faible volatilité (GPTD)',
        en: 'Low Volatility Global Equity (TDAM)',
      },
      properties: {
        id_beneva: 'AU',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '22',
      value: {
        fr: 'Marchés émergents (AGF)',
        en: 'Emerging Markets (AGF)',
      },
      properties: {
        id_beneva: 'AV',
        DtDb: '2011-10-10',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '23',
      value: {
        fr: 'Profil conservateur (AGF)',
        en: 'Conservative Profile (AGF)',
      },
      properties: {
        id_beneva: 'AW',
        DtDb: '2008-11-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '24',
      value: {
        fr: 'Profil modéré (AGF)',
        en: 'Moderate Profile (AGF)',
      },
      properties: {
        id_beneva: 'AX',
        DtDb: '2008-11-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '25',
      value: {
        fr: 'Profil équilibré (AGF)',
        en: 'Balanced Profile (AGF)',
      },
      properties: {
        id_beneva: 'AY',
        DtDb: '2008-11-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '26',
      value: {
        fr: 'Profil croissance (AGF)',
        en: 'Growth Profile (AGF)',
      },
      properties: {
        id_beneva: 'AZ',
        DtDb: '2008-11-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '27',
      value: {
        fr: 'Profil audacieux (AGF)',
        en: 'Aggressive Profile (AGF)',
      },
      properties: {
        id_beneva: 'BA',
        DtDb: '2008-11-03',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '28',
      value: {
        fr: 'Profil conservateur (BNI)',
        en: 'Conservative Profile (NBI)',
      },
      properties: {
        id_beneva: '',
        DtDb: '2013-12-09',
        DtEx: '2018-06-28',
        DtFi: '2018-09-17',
      },
    },
    {
      id: '29',
      value: {
        fr: 'Profil modéré (BNI)',
        en: 'Moderate Profile (NBI)',
      },
      properties: {
        id_beneva: '',
        DtDb: '2013-12-09',
        DtEx: '2018-06-28',
        DtFi: '2018-09-17',
      },
    },
    {
      id: '30',
      value: {
        fr: 'Profil équilibré (BNI)',
        en: 'Balanced Profile (NBI)',
      },
      properties: {
        id_beneva: '',
        DtDb: '2013-12-09',
        DtEx: '2018-06-28',
        DtFi: '2018-09-17',
      },
    },
    {
      id: '31',
      value: {
        fr: 'Profil croissance (BNI)',
        en: 'Growth Profile (NBI)',
      },
      properties: {
        id_beneva: '',
        DtDb: '2013-12-09',
        DtEx: '2018-06-28',
        DtFi: '2018-09-17',
      },
    },
    {
      id: '32',
      value: {
        fr: 'Profil audacieux (BNI)',
        en: 'Aggressive Profile (NBI)',
      },
      properties: {
        id_beneva: '',
        DtDb: '2013-12-09',
        DtEx: '2018-06-28',
        DtFi: '2018-09-17',
      },
    },
    {
      id: '33',
      value: {
        fr: 'Intérêt quotidien',
        en: 'Daily Interest',
      },
      properties: {
        id_beneva: 'BG',
        DtDb: '2015-04-14',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '34',
      value: {
        fr: 'Revenu fixe mondial (GMA CI)',
        en: 'Global Fixed Income (CI GAM)',
      },
      properties: {
        id_beneva: 'BH',
        DtDb: '2015-11-30',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '35',
      value: {
        fr: 'Actions américaines (Fiera Capital)',
        en: 'American Equity (Fiera Capital)',
      },
      properties: {
        id_beneva: 'BI',
        DtDb: '2015-11-30',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '36',
      value: {
        fr: 'Actions mondiales (Fiera Capital)',
        en: 'Global Equity (Fiera Capital)',
      },
      properties: {
        id_beneva: 'BJ',
        DtDb: '2015-11-30',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '37',
      value: {
        fr: 'Revenu diversifié mondial (Fidelity)',
        en: 'Global Diversified Income (Fidelity)',
      },
      properties: {
        id_beneva: 'BK',
        DtDb: '2016-01-18',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '38',
      value: {
        fr: 'Revenu fixe canadien (GMA CI)',
        en: 'Canadian Fixed Income (CI GAM)',
      },
      properties: {
        id_beneva: 'BL',
        DtDb: '2016-05-16',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '39',
      value: {
        fr: 'Actions américaines à faible volatilité (GPTD)',
        en: 'Low Volatility American Equity (TDAM)',
      },
      properties: {
        id_beneva: 'BM',
        DtDb: '2016-05-16',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '40',
      value: {
        fr: 'Dividendes mondiaux (GPTD)',
        en: 'Global Dividend (TDAM)',
      },
      properties: {
        id_beneva: 'BN',
        DtDb: '2016-12-05',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '41',
      value: {
        fr: 'Actions mondiales d’infrastructures (Dynamique)',
        en: 'Global Infrastructure Equity (Dynamic)',
      },
      properties: {
        id_beneva: 'BO',
        DtDb: '2016-12-05',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '42',
      value: {
        fr: 'Revenu fixe à haut rendement (GPTD)',
        en: 'High Yield Fixed Income (TDAM)',
      },
      properties: {
        id_beneva: 'BP',
        DtDb: '2018-11-12',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '43',
      value: {
        fr: 'Équilibré canadien (GMA CI)',
        en: 'Canadian Balanced (CI GAM)',
      },
      properties: {
        id_beneva: 'BQ',
        DtDb: '2018-11-12',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '44',
      value: {
        fr: 'Équilibré mondial (GMA CI)',
        en: 'Global Balanced (CI GAM)',
      },
      properties: {
        id_beneva: 'BR',
        DtDb: '2018-11-12',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '45',
      value: {
        fr: 'Actions mondiales (AGF)',
        en: 'Global Equity (AGF)',
      },
      properties: {
        id_beneva: 'BS',
        DtDb: '2018-11-12',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '46',
      value: {
        fr: 'Actions internationales (Fiera Capital)',
        en: 'International Equity (Fiera Capital)',
      },
      properties: {
        id_beneva: 'BT',
        DtDb: '2019-12-02',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '47',
      value: {
        fr: 'Actions mondiales Croissance durable (AGF)',
        en: 'Global Sustainable Growth Equity (AGF)',
      },
      properties: {
        id_beneva: 'BU',
        DtDb: '2019-12-02',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '48',
      value: {
        fr: 'Profil conservateur (Dynamique)',
        en: 'Conservative Profile (Dynamic)',
      },
      properties: {
        id_beneva: 'BV',
        DtDb: '2019-12-02',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '49',
      value: {
        fr: 'Profil modéré (Dynamique)',
        en: 'Moderate Profile (Dynamic)',
      },
      properties: {
        id_beneva: 'BW',
        DtDb: '2019-12-02',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '50',
      value: {
        fr: 'Profil équilibré (Dynamique)',
        en: 'Balanced Profile (Dynamic)',
      },
      properties: {
        id_beneva: 'BX',
        DtDb: '2019-12-02',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '51',
      value: {
        fr: 'Profil croissance (Dynamique)',
        en: 'Growth Profile (Dynamic)',
      },
      properties: {
        id_beneva: 'BY',
        DtDb: '2019-12-02',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '52',
      value: {
        fr: 'Profil audacieux (Dynamique)',
        en: 'Aggressive Profile (Dynamic)',
      },
      properties: {
        id_beneva: 'BZ',
        DtDb: '2019-12-02',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '53',
      value: {
        fr: 'Actions américaines petites-moyennes capitalisations (AGF)',
        en: 'U.S. Small-Mid Cap Equity (AGF)',
      },
      properties: {
        id_beneva: 'DA',
        DtDb: '2020-11-30',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '54',
      value: {
        fr: 'Indice canadien (GPTD)',
        en: 'Canadian Index (TDAM)',
      },
      properties: {
        id_beneva: 'DB',
        DtDb: '2026-04-26',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '55',
      value: {
        fr: 'Indice américain (GPTD)',
        en: 'U.S. Index (TDAM)',
      },
      properties: {
        id_beneva: 'DC',
        DtDb: '2026-04-26',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '56',
      value: {
        fr: 'Indice mondial (GPTD)',
        en: 'Global Index (TDAM)',
      },
      properties: {
        id_beneva: 'DD',
        DtDb: '2026-04-26',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '57',
      value: {
        fr: 'Croissance américaine (AGF)',
        en: 'American Growth (AGF)',
      },
      properties: {
        id_beneva: 'DE',
        DtDb: '2026-04-26',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '58',
      value: {
        fr: 'Croissance de dividendes (GPTD)',
        en: 'Dividend Growth (TDAM)',
      },
      properties: {
        id_beneva: 'DF',
        DtDb: '2026-10-20',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '59',
      value: {
        fr: 'Petites sociétés canadiennes (GPTD)',
        en: 'Canadian Small-Cap Equity (TDAM)',
      },
      properties: {
        id_beneva: 'DG',
        DtDb: '2026-10-20',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
    {
      id: '60',
      value: {
        fr: 'Innovations mondiales (Fidelity)',
        en: 'Global Innovators (Fidelity)',
      },
      properties: {
        id_beneva: 'DH',
        DtDb: '2026-10-20',
        DtEx: '2199-12-31',
        DtFi: '2199-12-31',
      },
    },
  ],
} satisfies ValueDefinition;
